import { styled } from '@nykaa/ui-components';

export const TopSectionContainer = styled.div`
  height: 218px;
  display: flex;
  margin-top: 56px;
  flex: auto;
  background: url('https://asset.footlocker.co.in/footlocker-images/rewards_bg.svg') no-repeat;
  background-size: cover;
  box-shadow: ${({ theme }) => theme.elevations.shadow100};
  z-index: 4;
`;

export const ImageSection = styled.div`
  height: fit-content;
  width: auto;
  display: flex;
  flex: auto;
  margin-top: ${({ theme }) => theme.spacing.spacing200};
  flex-direction: column;
  align-items: center;
  z-index: 4;
`;

export const ProfileImage = styled.img`
  height: 100px;
  max-width: 101px;
  width: 101px;
  display: flex;
  border-radius: 100%;
  flex: auto;
  background: white;
  z-index: 4;
`;

export const ProfileDetailsSection = styled.div<{ hide: boolean }>`
  height: auto;
  position: relative;
  min-height: 183px;
  display: flex;
  margin: -76px ${({ theme }) => theme.spacing.spacing120};
  flex: auto;
  flex-direction: column;
  background: white;
  border-radius: ${({ theme }) => theme.borders.radius10};
  border: 1px solid #f8f5f5;
  box-shadow: ${({ theme }) => theme.elevations.shadow100};
  padding: ${({ theme }) => theme.spacing.spacing80};
  z-index: 4;
  ${({ hide }) => hide && 'display: none;'}
`;

export const HeaderContainer = styled.div`
  margin-left: ${({ theme }) => theme.spacing.spacing60};
  align-self: baseline;
`;

export const HeaderText = styled.img`
  width: 118px;
  height: 24px;
  background-repeat: no-repeat;
`;

export const FirstSection = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  flex-direction: column;
  padding: 0 0 ${({ theme }) => theme.spacing.spacing60} 0;
  border-bottom: 0.5px solid #0000001a;
`;

export const SecondSection = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  padding: ${({ theme }) => theme.spacing.spacing60} 0;
  border-bottom: 0.5px solid #0000001a;
`;

export const ThirdSection = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.primary};
  display: flex;
  padding-top: ${({ theme }) => theme.spacing.spacing80};
`;

export const RewardsHeading = styled.div`
  ${({ theme }) => theme.typography.buttonMedium};
  color: ${({ theme }) => theme.colors.primary};
`;

export const MemberSince = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.primary};
`;

export const PointsSection = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.primary};
  flex: 0.6;
`;

export const Spent = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  color: ${({ theme }) => theme.colors.primary};
  flex: 0.4;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-self: flex-end;
`;

export const ViewHistory = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  color: ${({ theme }) => theme.colors.primary};
  flex: 0.5;
`;

export const HistoryButton = styled.div`
  ${({ theme }) => theme.typography.titleSmall};
  color: ${({ theme }) => theme.colors.primary};
  flex: 0.5;
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const RewardPointHeading = styled.div`
  ${({ theme }) => theme.typography.bodySmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
`;
export const Points = styled.div`
  ${({ theme }) => theme.typography.buttonMedium};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
  margin-right: 8px;
`;
export const Expiry = styled.div`
  ${({ theme }) => theme.typography.bodyXSmall};
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
`;

export const PointsDisplay = styled.div`
  ${({ theme }) => `
      color: ${theme.colors.primary};
    `};
  display: flex;
  align-items: center;
`;
